/**
 * 登录页相关的reducer
 */
import { combineReducers } from 'redux'
import * as ACTIONS from '../actions/login_action';

const loginErrorMsg = (state = "", action) => {
    switch (action.type) {
        case ACTIONS.SET_LOGIN_ERROR_MSG:
            return action.msg;
        default:
            return state;
    }
}

const needSelectRole = (state = false, action)=>{
   switch(action.type){
     case ACTIONS.SET_NEED_SELECT_ROLE:
      return action.needSelectRole;
    default:
      return state;
   }
}
//设置跳转路由
function toUrl(state = "", action) {
    switch (action.type) {
        case ACTIONS.SET_LOGIN_TOURL:
            return action.toUrl;
        default:
            return state;
    }
}

//登录类型：react 或 rap
function loginType(state = 'react', action) {
    switch (action.type) {
        case ACTIONS.SET_LOGIN_TYPE:
            return action.loginType
        default:
            return state
    }
}

function authenticationData(state = null, action) {
  switch (action.type) {
    case ACTIONS.SET_AUTHENTICATIONDATA:
      return action.authenticationData;
    default:
      return state;
  }
}

function licenseList(state = [], action) {
  switch (action.type) {
    case ACTIONS.SET_LICENSELIST:
      return action.licenseList;
    default:
      return state;
  }
}

const loginReducer = combineReducers({
    loginErrorMsg,
    needSelectRole,
    toUrl,
    loginType,
    authenticationData,
    licenseList
})

export default loginReducer
